import { render, staticRenderFns } from "./BER-Column-City.vue?vue&type=template&id=ae47dfe0&"
import script from "./BER-Column-City.vue?vue&type=script&lang=js&"
export * from "./BER-Column-City.vue?vue&type=script&lang=js&"
import style0 from "./BER-Column-City.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports